/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './Currency';
import type { LaundryGroupPriceListElementIntegrated } from './LaundryGroupPriceListElementIntegrated';
import {
    LaundryGroupPriceListElementIntegratedFromJSON,
    LaundryGroupPriceListElementIntegratedFromJSONTyped,
    LaundryGroupPriceListElementIntegratedToJSON,
} from './LaundryGroupPriceListElementIntegrated';
import type { MachineType } from './MachineType';
import {
    MachineTypeFromJSON,
    MachineTypeFromJSONTyped,
    MachineTypeToJSON,
} from './MachineType';

/**
 * 
 * @export
 * @interface LaundryGroupPriceListIntegrated
 */
export interface LaundryGroupPriceListIntegrated {
    /**
     * 
     * @type {string}
     * @memberof LaundryGroupPriceListIntegrated
     */
    name: string;
    /**
     * 
     * @type {MachineType}
     * @memberof LaundryGroupPriceListIntegrated
     */
    machineType: MachineType;
    /**
     * Drum Size of machine in kg (Optional)
     * @type {number}
     * @memberof LaundryGroupPriceListIntegrated
     */
    drumSize?: number | null;
    /**
     * Unit of Weight ('kg' | 'lbs')
     * @type {string}
     * @memberof LaundryGroupPriceListIntegrated
     */
    drumSizeUnit?: string;
    /**
     * 
     * @type {Currency}
     * @memberof LaundryGroupPriceListIntegrated
     */
    currency: Currency;
    /**
     * 
     * @type {string}
     * @memberof LaundryGroupPriceListIntegrated
     */
    readonly regularPriceListId: string;
    /**
     * 
     * @type {string}
     * @memberof LaundryGroupPriceListIntegrated
     */
    readonly happyHourPriceListId: string;
    /**
     * 
     * @type {Array<LaundryGroupPriceListElementIntegrated>}
     * @memberof LaundryGroupPriceListIntegrated
     */
    prices: Array<LaundryGroupPriceListElementIntegrated>;
}

/**
 * Check if a given object implements the LaundryGroupPriceListIntegrated interface.
 */
export function instanceOfLaundryGroupPriceListIntegrated(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "machineType" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "regularPriceListId" in value;
    isInstance = isInstance && "happyHourPriceListId" in value;
    isInstance = isInstance && "prices" in value;

    return isInstance;
}

export function LaundryGroupPriceListIntegratedFromJSON(json: any): LaundryGroupPriceListIntegrated {
    return LaundryGroupPriceListIntegratedFromJSONTyped(json, false);
}

export function LaundryGroupPriceListIntegratedFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaundryGroupPriceListIntegrated {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'machineType': MachineTypeFromJSON(json['machineType']),
        'drumSize': !exists(json, 'drumSize') ? undefined : json['drumSize'],
        'drumSizeUnit': !exists(json, 'drumSizeUnit') ? undefined : json['drumSizeUnit'],
        'currency': CurrencyFromJSON(json['currency']),
        'regularPriceListId': json['regularPriceListId'],
        'happyHourPriceListId': json['happyHourPriceListId'],
        'prices': ((json['prices'] as Array<any>).map(LaundryGroupPriceListElementIntegratedFromJSON)),
    };
}

export function LaundryGroupPriceListIntegratedToJSON(value?: LaundryGroupPriceListIntegrated | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'machineType': MachineTypeToJSON(value.machineType),
        'drumSize': value.drumSize,
        'drumSizeUnit': value.drumSizeUnit,
        'currency': CurrencyToJSON(value.currency),
        'prices': ((value.prices as Array<any>).map(LaundryGroupPriceListElementIntegratedToJSON)),
    };
}

